<script setup lang="ts">
const props = defineProps<{
  to?: string
  label: string
  icon?: string
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <UButton
    :to="props.to"
    :label="props.label"
    :icon="props.icon"
    target="_blank"
    rel="noopener noreferrer"
    block
    @click="emit('click')"
  />
</template>
